import{directive as i}from"lit/directive.js";import{AsyncDirective as t}from"lit/async-directive.js";
/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const s=i(class extends t{render(i){var t;if(i!==this._$Oi){null===(t=this._$Oo)||void 0===t||t.call(this),this._$Oi=i;let s=!0;this._$Oo=i.subscribe((i=>{!1===s&&this.setValue(i)})),s=!1}return i.peek()}disconnected(){var i;null===(i=this._$Oo)||void 0===i||i.call(this)}reconnected(){var i;this._$Oo=null===(i=this._$Oi)||void 0===i?void 0:i.subscribe((i=>{this.setValue(i)}))}});export{s as watch};
//# sourceMappingURL=watch.js.map
